<template>
  <div class="Readily">
    <div class="content">
      <titleStyle title="群众随手拍" :icon="()=>require(`@/assets/template/${$store.getters.moduleName}/input9icon/1.png`)" />
      <component
        :is="path"
        ref="editOrCreate"
        style="background: #fff;"
        :form-type="formType"
        :method-path="methodPath"
        @reFresh="reFresh"
      />
    </div>
  </div>
</template>

<script>
import titleStyle from '@/components/titleStyle/index.vue'
export default {
  components: { titleStyle },
  data() {
    var checkTel = (rule, value, callback) => { // 编辑验证
      const re = /^1[3456789]{1}\d{9}$/
      if (!re.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      }
      callback()
    }
    var options = [{ // 编辑下拉框内容
      options: [{
        value: '0',
        label: '请选择广告位置'
      }, {
        value: '门户站首页轮播',
        label: '门户站首页轮播'
      }, {
        value: '门户站首页中间通栏',
        label: '门户站首页中间通栏'
      }, {
        value: '门户站首页右2',
        label: '门户站首页右2'
      }]
    }]
    return {
      methodPath: { // 接口必传
        create: 'home/ReadilyAddReadily' // 创建接口
      },
      path: () => import('@/components/tableComponent/editOrCreate.vue'), // 编辑页面,如需要自定义可以引用自己的文件
      formType: {
        title: {
          label: '民情简介',
          message: '请输入民情简介'
        },
        contacts: { label: '联系人', message: '请输入联系人' },
        tel: { label: '联系电话', validator: checkTel },
        reportType: { label: '类型', type: 'select', options, message: '请选择类型' }, // 下拉选择
        context: { // 富文本
          label: '详细内容',
          type: 'rich'
        }
        // pbId: { // 自定义功能
        //   label: '权限', // 必传
        //   type: 'custom', // 必传
        //   component: () => import('./components/custom.vue'), message: '请输入权限', // 必传,自定义组件的路径
        //   data: { name: 1, age: '需要传入的参数' } // 非必传,这个是想要代入组件的参数
        // }
        // type: { // 单选框
        //   label: '权限',
        //   type: 'deform',
        //   data: { '1': '超级管理员', '2': '支部管理员' } // 必传, key为返回值,value为显示的内容
        // }

      }
    }
  },

  mounted() {

  },
  created() {
    this.getTypeList() // 获取下拉分类
  },

  methods: {
    getTypeList() {
      this.$store.dispatch('home/ReadilyGetReadilyType').then(res => {
        if (res.code === 0) {
          this.formType.reportType.options[0].options = res.data.map(item => {
            item.value = item.name
            item.label = item.name
            delete item.name
            return item
          })
        }
      })
    },
    reFresh() {
      this.$go('/personal/Readily?selected=0')
    }
  }
}
</script>

<style lang="scss" scoped>
  .Readily{
    background: #f5f9fa;
    flex: 1;
    .content{
      display: flex;
      flex-direction: column;
      width: 1300px;
      background: #fff;
      margin: 0px auto 118px auto;
      padding: 30px 0 87px 32px;      position: relative;
      top: 20px;
    }
  }
</style>
